import { render, staticRenderFns } from "./MessageStudentDialog.vue?vue&type=template&id=32e2c6fd"
import script from "./MessageStudentDialog.vue?vue&type=script&lang=js"
export * from "./MessageStudentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports